import dayjs from 'dayjs'
import { requestOrThrow } from '../api-client'
import type { BookingEntry, Menu, TimeSlot } from '../booking-entry'

export function getBookingMenus(storeIdAlias: string) {
  return requestOrThrow<Menu[]>(`/stores/${storeIdAlias}/booking_menus`)
}

export function getBookingTimeSlotsByMenu({
  storeIdAlias,
  menuId,
  fromOn,
  toOn,
  targetGroupMemberId,
}: {
  storeIdAlias: string
  menuId: number
  fromOn: Date
  toOn: Date
  targetGroupMemberId?: number
}) {
  return requestOrThrow<TimeSlot>(
    `/stores/${storeIdAlias}/booking_menus/${menuId}/time_slots`,
    {
      params: {
        target_on_from: dayjs(fromOn).format('YYYY-MM-DD'),
        target_on_to: dayjs(toOn).format('YYYY-MM-DD'),
        // 代理予約の対象者(本人=メインの pgm id / メンバー=サブメンバーの pgm id)。省略時は本人。
        ...(targetGroupMemberId != null ? { target_group_member_id: targetGroupMemberId } : {}),
      },
      skipConvertKeyRecursivelyOnResponse: true,
    }
  )
}

export function bookBookingMenu({
  storeIdAlias,
  menuId,
  fromAt,
  note,
  targetGroupMemberId,
}: {
  storeIdAlias: string
  menuId: number
  fromAt: string
  note?: string
  targetGroupMemberId?: number
}) {
  return requestOrThrow<BookingEntry>(`/stores/${storeIdAlias}/booking_menus/${menuId}/book`, {
    method: 'POST',
    body: {
      fromAt,
      note,
    },
    credentials: 'include',
    // 代理予約の対象者(query)。本人=メインの pgm id / メンバー=サブメンバーの pgm id。省略時は本人。
    query: targetGroupMemberId != null ? { targetGroupMemberId } : undefined,
  })
}
